// CSS Modules - component class name prefix: ContentTeaserM__

<template>
  <figure :class="$style.container">
    <a
      :class="[{ ContentTeaserM__videoLink: isVideo }, $style.mediaLink]"
      :href="primaryLink"
      :target="primaryLinkNewWindow ? '_blank' : '_self'"
      aria-label="goto detail"
      @click="
        wtParams &&
          wtTrack(
            {
              cat: wtParams.doctype
            },
            mergeWtParams(
              wtParams,
              {
                filename: primaryLink
              },
              {}
            )
          )
      "
    >
      <div :class="$style.image" :style="{ backgroundImage: `url(${image})` }">
        <img :src="image" alt="" />
      </div>
      <i v-if="isVideo" class="fab fa-youtube"></i>
    </a>
    <figcaption>
      <a
        v-if="category"
        :class="$style.secondaryLink"
        :href="secondaryLink"
        :target="secondaryLinkNewWindow ? '_blank' : '_self'"
        >{{ category }}
      </a>
      <a
        v-if="linkTitle"
        :class="$style.primaryLink"
        :href="primaryLink"
        :target="primaryLinkNewWindow ? '_blank' : '_self'"
        @click="
          wtParams &&
            wtTrack(
              {
                cat: wtParams.doctype
              },
              mergeWtParams(
                wtParams,
                {
                  filename: primaryLink
                },
                {}
              )
            )
        "
      >
        {{ linkTitle }}
        <div v-if="text">{{ text }}</div>
      </a>
    </figcaption>
  </figure>
</template>

<script>
import { mergeSwitchWtParams } from "../../utils/tracking";

export default {
  name: "ContentTeaserM",
  props: {
    isVideo: {
      type: Boolean,
      default: false
    },
    primaryLink: {
      type: String,
      default: ""
    },
    primaryLinkNewWindow: {
      type: Boolean,
      default: true
    },
    secondaryLink: {
      type: String,
      default: ""
    },
    secondaryLinkNewWindow: {
      type: Boolean,
      default: true
    },
    category: {
      type: String,
      default: ""
    },
    linkTitle: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    wtParams: Object
  },
  methods: {
    mergeWtParams(globalWtParams, itemWtParams, itemParams) {
      return mergeSwitchWtParams(globalWtParams, itemWtParams, itemParams);
    }
  },
  data() {
    return {
      wtTrack: window.wtTrack
    };
  }
};
</script>

<style module lang="scss">
@import "./ContentTeaserM.scss";
</style>
